"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.visible = void 0;

var visible = function visible(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;
  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.visible = visible;
var _default = visible;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-grid-system/build/utilities/Visible/style.js
// module id = 59
// module chunks = 0